(() => {
  if (customElements.get('cro-product-tabs')) return;
  let instance = 0;
  customElements.define('cro-product-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      this.tabs = Array.from(this.querySelectorAll('[data-cro-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-cro-panel]'));
      if (!this.tabs.length) return;
      const prefix = `cro-product-tabs-${++instance}`;
      const nav = this.querySelector('.cro-product-tabs__nav');
      nav.setAttribute('role', 'tablist');
      nav.hidden = false;
      this.tabs.forEach((tab, index) => {
        tab.id = `${prefix}-tab-${index}`;
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', `${prefix}-panel-${index}`);
        const panel = this.panels[index];
        panel.id = `${prefix}-panel-${index}`;
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tab.id);
        panel.tabIndex = 0;
      });
      const click = event => {
        const tab = event.target.closest('[data-cro-tab]');
        if (this.tabs.includes(tab)) this.select(this.tabs.indexOf(tab));
      };
      const keydown = event => {
        const index = this.tabs.indexOf(event.target);
        if (index < 0) return;
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        this.select(next);
        this.tabs[next].focus();
      };
      this.media = window.matchMedia('(min-width: 990px)');
      const resize = () => {
        if (!this.getClientRects().length) this.clearVideo();
      };
      nav.addEventListener('click', click);
      nav.addEventListener('keydown', keydown);
      this.media.addEventListener('change', resize);
      this.cleanup = () => {
        nav.removeEventListener('click', click);
        nav.removeEventListener('keydown', keydown);
        this.media.removeEventListener('change', resize);
      };
      this.setAttribute('data-enhanced', '');
      this.select(0, false);
    }
    disconnectedCallback() {
      this.clearVideo();
      this.cleanup?.();
      this.cleanup = null;
    }
    clearVideo() {
      this.querySelectorAll('.cro-product-tabs__player iframe').forEach(frame => frame.remove());
    }
    select(index, userAction = true) {
      this.tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
        this.panels[i].hidden = i !== index;
      });
      this.clearVideo();
      const panel = this.panels[index];
      if (!userAction || !panel.dataset.videoUrl) return;
      let url;
      try { url = new URL(panel.dataset.videoUrl); } catch { return; }
      if (url.protocol !== 'https:' || !/(^|\.)tiktok\.com$/i.test(url.hostname)) return;
      const match = url.pathname.match(/\/video\/(\d+)(?:\/|$)/);
      // Short share links keep the visible external link; no guessed video ID.
      if (!match) return;
      const frame = document.createElement('iframe');
      frame.src = `https://www.tiktok.com/player/v1/${match[1]}?autoplay=0&rel=0`;
      frame.title = 'Vídeo del producto en TikTok';
      frame.allow = 'fullscreen';
      frame.allowFullscreen = true;
      panel.querySelector('.cro-product-tabs__player').append(frame);
    }
  });
})();
